import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';

@Component({
	selector: 'peps-checkbox',
	imports: [
		NgOptimizedImage
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './checkbox.component.html',
})
export class CheckboxComponent {

	@Input() checked: boolean = false;
	@Input() image: string = '';
	@Input() alt: string = '';

	@Output() onCheckChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	toggleCheck() {
		this.onCheckChange.emit(!this.checked);
	}

}
